import React from "react";
import moment from "moment";
//import { useNavigate } from "react-router-dom";
import apt from "../../assets/images/apt.png";
import ApptCard from "./appt-card";
import Loader from "../elements/loader";

type RecentApptsProps = {
  loading: boolean;
  data: any[] | null;
  date: Date;
  setDate?: (d: Date) => void;
};

export default function RecentAppts(props: RecentApptsProps) {
  //const navigate = useNavigate();
  const { loading, data, date } = props;

  return (
    <div className="min-h-64 p-5">
      <h2 className="text-sm font-semibold text-slate-700 tracking-tight">
        Appointments — {moment(date).format("Do MMMM YYYY")}
      </h2>

      <div className="mt-4 flex flex-col gap-3">
        {loading ? (
          <Loader num={3} />
        ) : data !== null && data.length > 0 ? (
          data.map((v: any, idx: number) => (
            <ApptCard key={v.id ?? idx} data={v} />
          ))
        ) : (
          <div className="flex flex-col justify-center items-center py-10 px-4 text-center">
            <img
              src={apt}
              alt=""
              className="h-28 w-auto object-contain opacity-80"
            />
            <h3 className="mt-4 text-sm font-medium text-slate-600">
              No appointments this day
            </h3>
            <p className="mt-1 text-xs text-slate-500">
              View and manage all appointments below
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
